import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="app-shell flex items-center justify-center">
        <p className="text-muted-foreground text-sm tracking-wide uppercase">Loading…</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/welcome" replace />;
  return children;
}
